import duotone from "icons/duotone";
import StaticVar from "config/StaticVar";
import { generateSSOToken } from "services/authService";

export const navigations = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: duotone.LayerGroup,
  },
  {
    type: "label",
    label: "Manajemen Konten",
  },
  {
    name: "Tipe Konten",
    icon: duotone.ElementHub,
    path: "/content/type",
  },
  {
    name: "Konten",
    icon: duotone.Chat,
    children: [
      {
        name: "Artikel",
        path: "/content/article/list",
      },
      {
        name: "Berita",
        path: "/content/news/list",
      },
    ],
  },
  {
    name: "Galeri",
    icon: duotone.Chat,
    children: [
      {
        name: "Foto",
        path: "/gallery/photo",
      },
      {
        name: "Video",
        path: "/gallery/video",
      },
    ],
  },
  {
    type: "label",
    label: "Manajemen Portal",
  },
  {
    name: "Banner Slide",
    icon: duotone.ElementHub,
    path: "/banner",
  },
  {
    name: "Dokumen",
    icon: duotone.ElementHub,
    children: [
      {
        name: "Kategori",
        path: "/document/category",
      },
      {
        name: "List",
        path: "/document/",
      },
    ],
  },
  {
    name: "Laman",
    icon: duotone.ElementHub,
    path: "/page",
  },
  {
    name: "Sitemap",
    icon: duotone.ElementHub,
    path: "/sitemap",
  },
  {
    name: "Organisasi",
    icon: duotone.ElementHub,
    path: "/organization",
  },
  {
    name: "Struktur Organisasi",
    icon: duotone.ElementHub,
    path: "/organization-structure",
  },
  {
    name: "Unit Organisasi",
    icon: duotone.ElementHub,
    path: "/organization-unit",
  },
  {
    name: "Benefit",
    icon: duotone.ElementHub,
    path: "/benefit",
  },
  {
    name: "Visi & Misi",
    icon: duotone.ElementHub,
    path: "/visi-misi",
  },
  {
    name: "Statistik",
    icon: duotone.ElementHub,
    path: "/statistics",
  },
  {
    name: "Partner",
    icon: duotone.ElementHub,
    path: "/partner",
  },
  {
    name: "Event",
    icon: duotone.ElementHub,
    path: "/event",
  },
  {
    name: "FAQ",
    icon: duotone.ElementHub,
    path: "/faq",
  },
  {
    name: "Popup",
    icon: duotone.ElementHub,
    path: "/popup",
  },
  {
    name: "Survey",
    icon: duotone.ElementHub,
    path: "/survey",
  },
  {
    type: "label",
    label: "Manajemen User",
  },
  {
    name: "User",
    icon: duotone.Accounts,
    path: "/users",
  },
  {
    name: "Role",
    icon: duotone.Accounts,
    path: "/role",
  },
  {
    name: "Page Management",
    icon: duotone.Accounts,
    path: "/page-management",
  },
  {
    type: "label",
    label: "Konfigurasi",
  },
  {
    name: "App Config",
    path: "/app-config",
    icon: duotone.Settings,
  },
  {
    type: "label",
    label: "Manajemen Membership",
  },
  {
    type: "extLinkSSO",
    name: "Web Membership",
    icon: duotone.Pages,
    path: `${StaticVar.URL_MEMBER}/oauth-success`, // Store base URL
    pathParams: {
      ssoTokenParam: "ssoToken",
      tokenGenerator: generateSSOToken,
    },
  },
  {
    type: "label",
    label: "Manajemen Pembayaran",
  },
  {
    type: "extLinkSSO",
    name: "Web Pembayaran",
    icon: duotone.Pages,
    path: `${StaticVar.URL_PAYMENT}/oauth-success`, // Store base URL
    pathParams: {
      ssoTokenParam: "ssoToken",
      tokenGenerator: generateSSOToken,
    },
  },
];
